import React, { useEffect } from 'react';
import { Container, Row, Col, Spinner, Card, CardHeader, CardBody } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import client from '../../utils/client';

const InvoicePdf = () => {
  const location = useLocation();

  useEffect(() => {
    const params = qs.parse(location.search, {
      ignoreQueryPrefix: true
    });

    if (params.invoiceId) {
      downLoadInvoice(params.invoiceId);
    }
  }, []);

  const downLoadInvoice = async (invoiceId) => {
    client(`admin-gc/invoices/${invoiceId}?from-fortnox-pdf=1`, {}, 'GET', true);
  };

  return (
    <>
      <SimpleHeader name="Faktura" />

      <Container className="mt--6" fluid>
        <Row>
          <Col xs="12" md="9">
            <Card>
              <CardHeader>
                <h3 className="mb-0">Fakturor</h3>
              </CardHeader>
              <CardBody>
                <Spinner size="lg" className="mr-3" />
                Hämtar faktura
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default InvoicePdf;
